import { Grid } from '@mui/material';
import { BoxContainer } from '../Containers/BoxContainer';
import '../../css/Dashboard.css';

export const DashboardGrid = (props) => {
  return (
    <Grid sx={{ padding: '12px' }} item xs={12} sm={12} md={props.md}>
      <BoxContainer bg={{ bgcolor: 'rgb(26, 32, 44, 0.85)' }}>
        {props.children}
      </BoxContainer>
    </Grid>
  );
};
